import * as Types from '../types.generated'

import { gql } from '@apollo/client'
export const ConsortiumsListItemFragmentDoc = gql`
  fragment ConsortiumsListItem on Consortium {
    id
    name
    description
    slug
    frameworks {
      name
    }
    logo {
      url
      isBright
    }
  }
`
export type ConsortiumsListItemFragment = {
  __typename?: 'Consortium'
  id: string
  name: string
  description: string
  slug: string
  frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
  logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
}
